import { configureStore } from "@reduxjs/toolkit";
import userManagementReducer from './users/userManagementSlice';
import clientManagementReducer from "./clients/clientManagementSlice";
import authenticationReducer from "./auth/authenticationSlice";
import jobsManagementReducer from "./jobs/jobManagementSlice";
import leadsManagementReducer from "./leads/leadManagementSlice"


export const store = configureStore({
  reducer: {
    userManagement: userManagementReducer,
    clientManagement: clientManagementReducer,
    authentication: authenticationReducer,
    jobsManagement: jobsManagementReducer,
    leadsManagement:leadsManagementReducer
  },
  middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
});
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;